import type { RefObject } from "react";
import { TextareaOverlay } from "./GhostText";

type Props = {
  textareaRef: RefObject<HTMLTextAreaElement | null>;
  value: string;
  range: { start: number; end: number } | null;
};

export const streamingTextareaStyle = {
  color: "transparent",
  caretColor: "var(--text-primary)",
};

export function StreamingDictation({ textareaRef, value, range }: Props) {
  if (!range) return null;
  return (
    <TextareaOverlay textareaRef={textareaRef}>
      {value.slice(0, range.start)}
      <span
        style={{
          color: "var(--text-primary)",
          opacity: 0.4,
          fontStyle: "italic",
        }}
      >
        {value.slice(range.start, range.end)}
      </span>
      {value.slice(range.end)}
    </TextareaOverlay>
  );
}
